<template>
  <a
    v-tag="tagging"
    class="product-purchase-button product-button ripple-animation ripple-animation--black"
    href="#"
    :class="classes"
    @click="onClick"
  >
    <slot />
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'product-purchase-button',
  props: {
    product: {
      type: Object,
      required: false,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    addToCartTagging: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick(event) {
      event.preventDefault();

      if (!this.disabled && !this.loading) {
        this.addToCart();
      }
    },
    addToCart() {
      this.loading = true;

      this.$store
        .dispatch('cart/add', {
          origin: this.apiUrl,
          item: {
            id: this.product.sku,
            seller: this.product.seller,
            quantity: 1,
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
    tokenReplacement(value, culture) {
      // NOSONAR
      let text = null;
      let json = '';
      text = this.addToCartTagging;

      text = this.doSubstitution(text, '[VtexProductId]', value['ean'] || 'none');
      text = this.doSubstitution(
        text,
        '[InStock]',
        value['quantity'] ? 'in stock' : 'out of stock',
      );
      text = this.doSubstitution(text, '[VtexProductPrice]', value['price']['current'] || 'none');
      text = this.doSubstitution(text, '[VtexProductName]', value['name'].toLowerCase());
      text = this.doSubstitution(text, '[VtexProductQuantity]', value['quantity'] || 'none');
      text = this.doSubstitution(
        text,
        '[VtexProductCategories]',
        value['categories'].join(',') || 'none',
      );
      text = this.doSubstitution(text, '[CurrencyCode]', culture['currency'] || 'none');

      if (text) {
        json = JSON.parse(text);
        if (json.ecommerce.add.products && json.ecommerce.add.products.length) {
          if (json.ecommerce.add.products[0].price !== 'none') {
            json.ecommerce.add.products[0].price = Number(json.ecommerce.add.products[0].price);
          }
          if (json.ecommerce.add.products[0].quantity !== 'none') {
            json.ecommerce.add.products[0].quantity = Number(
              json.ecommerce.add.products[0].quantity,
            );
          }
        }
        return json;
      } else {
        return {};
      }
    },
    doSubstitution(text, key, value) {
      const index = text.indexOf(key);
      if (index > -1) {
        return text.replaceAll(key, value);
      }
      return text;
    },
  },
  computed: {
    classes() {
      return {
        'product-purchase-button--loading': this.loading,
        'product-purchase-button--disabled': this.disabled,
      };
    },
    tagging() {
      return this.tokenReplacement(this.product, this.culture);
    },
    ...mapGetters('cart', ['culture']),
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style lang="scss" src="./product-purchase-button.scss"></style>
